import Web3 from "web3";
import React, { Fragment } from "react";
import NotificationSystem from "react-notification-system";
import {
  Card,
  CardBody,
  Col,
  Table,
  Button,
} from "reactstrap";
import { IoMdEye } from "react-icons/io";
import { FaBoxes } from "react-icons/fa";
import { ImPriceTag } from "react-icons/im";
import { RiKey2Fill } from "react-icons/ri";
import { BsFillClockFill } from "react-icons/bs";
import Page from "../../components/Page";
import MembershipEdit from "./MembershipEdit";
import MembershipDetail from "./MembershipDetail";
import PageSpinner from "../../components/PageSpinner";
import config from "../../config/local";
import membershipABI from "../../contracts_abi/membership.json";
import { NOTIFICATION_SYSTEM_STYLE } from "../../utils/constants";

export const contractAddress = config.contractAddress;

class Membership extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      membership: {},
      memberships: [],
      showLoader: false,
      editMembership: false,
      membershipEditPage: false,
      membershipDetailPage: false
    };
  }

  componentDidMount() {
    this.getMemberships();
  }

  getMemberships = async (type) => {
    try {
      const account = localStorage.getItem('walletAddress');
      const web3 = new Web3(Web3.givenProvider);
      const myContract = await new web3.eth.Contract(membershipABI, contractAddress);
      const memberships = await myContract.methods
        .getUserCreatedMembership()
        .call(
          {
            from: account
          }
        );
      console.log({ memberships });
      if (memberships && memberships.length) {
        this.setState({
          showLoader: false,
          memberships: memberships.map(membership => (
            {
              membershipId: membership._id,
              membershipName: membership.membershipName,
              membershipPrice: membership.membershipPrice,
              membershipDuration: membership.membershipDuration,
              membershipCount: membership.membershipCount,
              membershipSold: membership.membershipSold,
              unlimitedCount: membership.unlimitedCount,
              unlimitedDuration: membership.unlimitedDuration,
              freeMembership: membership.freeMembership,
            }
          ))
        });
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  rendermembershipEditPage = (membership, key) => {
    this.setState({ membership, membershipEditPage: true, editMembership: key });
  };

  closeMembershipEditPage = async (obj) => {
    this.setState({ membershipEditPage: false });
    if (obj.refreshList) {
      this.getMemberships();
    }
  };

  toggleMembershipDetailPage = (membership) => {
    this.setState({
      membership: membership ? membership : {},
      membershipDetailPage: !this.state.membershipDetailPage
    });
  };

  render() {
    return (
      <Fragment>
        {this.state.membershipEditPage ? (
          <MembershipEdit
            history={this.props.history}
            membership={this.state.membership}
            editMembershipKey={this.state.editMembership}
            closeMembershipEditPage={(event) => this.closeMembershipEditPage(event)}
          ></MembershipEdit>
        ) : (
          this.state.membershipDetailPage ?
            <MembershipDetail
              history={this.props.history}
              membership={this.state.membership}
              toggleMembershipDetailPage={this.toggleMembershipDetailPage}
            ></MembershipDetail>
            :
            <div>
              <PageSpinner showLoader={this.state.showLoader} />
              <Page
                title="Memberships"
                breadcrumbs={[{ name: "Memberships", active: true }]}
              >
                <Col className="pl-0">
                  <Card className="mb-3">
                    <CardBody>
                      <Button
                        style={{ float: "right", marginBottom: "10px" }}
                        onClick={(event) =>
                          this.rendermembershipEditPage({}, false)
                        }
                      >
                        Add Membership
                      </Button>
                      <Table striped hover responsive>
                        <thead>
                          <tr className="text-center">
                            <th>Membership Id</th>
                            <th>Name</th>
                            <th>
                              <ImPriceTag size="10" className="mr-1" />
                              Price
                            </th>
                            <th>
                              <BsFillClockFill size="10" className="mr-1" />
                              Key Duration
                            </th>
                            <th>
                              <FaBoxes size="10" className="mr-1" />
                              Key Quantity
                            </th>
                            <th>
                              <RiKey2Fill size="15" className="mr-1" />
                              Key Sold
                            </th>
                            <th>Detail</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.memberships &&
                            this.state.memberships.length > 0 ? (
                            this.state.memberships.map((membership, index) => (
                              <tr key={index}>
                                <td align="center">
                                  <div style={{ width: '170px' }}>{membership.membershipId}</div>
                                </td>
                                <td align="center" style={{ width: "20%" }}>
                                  <div>{membership.membershipName}</div>
                                </td>
                                <td align="center">
                                  <div>
                                    <img
                                      width="30px"
                                      height="auto"
                                      src="https://image.zocial.io/zencafe/polygon_matic.png"
                                    />
                                    {
                                      membership.freeMembership
                                        ? 0
                                        : membership.membershipPrice
                                    }
                                  </div>
                                </td>
                                <td align="center">
                                  <div>{
                                    membership.unlimitedDuration
                                      ? 'Unlimited'
                                      : membership.membershipDuration
                                  }</div>
                                </td>
                                <td align="center">
                                  <div>{
                                    membership.unlimitedCount
                                      ? 'Unlimited'
                                      : membership.membershipCount
                                  }</div>
                                </td>
                                <td align="center">
                                  <div>{membership.membershipSold}</div>
                                </td>
                                <td align="center">
                                  <IoMdEye
                                    size="25"
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => this.toggleMembershipDetailPage(membership)}
                                  />
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="7" className="text-center">
                                No memberships found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                    </CardBody>
                  </Card>
                </Col>
                <NotificationSystem
                  dismissible={false}
                  ref={(notificationSystem) =>
                    (this.notificationSystem = notificationSystem)
                  }
                  style={NOTIFICATION_SYSTEM_STYLE}
                />
              </Page>
            </div>

        )}
      </Fragment>
    );
  }
}
export default Membership;
